import React from 'react';
import { motion } from 'framer-motion';

const Logo = ({ darkMode }) => {
  // Animation variants
  const svgVariants = {
    hover: {
      rotate: [0, 5, 0],
      transition: { duration: 1.2, ease: "easeInOut" }
    }
  };

  const pathVariants = {
    hover: {
      scale: 1.05,
      transition: { duration: 0.8, ease: "easeInOut" }
    }
  };

  const textVariants = {
    hover: {
      y: [-1, 1, -1],
      transition: { duration: 1.5, ease: "easeInOut", repeat: Infinity, repeatType: "mirror" }
    }
  };

  return (
    <motion.div 
      className="flex items-center space-x-3"
      whileHover="hover"
      initial="initial"
    >
      {/* Logo Mark */}
      <motion.svg 
        className="h-10 w-auto" 
        viewBox="0 0 50 50" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        variants={svgVariants}
      >
        {/* Wealth Building Blocks */}
        <motion.path 
          d="M10 35L25 10L40 35H10Z" 
          className={darkMode ? 'fill-white/80' : 'fill-secondary-500'}
          variants={pathVariants}
        />
        <motion.path 
          d="M10 35L25 20L40 35H10Z" 
          className={darkMode ? 'fill-white' : 'fill-primary-500'}
          variants={pathVariants}
        />
        <motion.path 
          d="M15 35L25 25L35 35H15Z" 
          className={darkMode ? 'fill-white/60' : 'fill-secondary-400'}
          variants={pathVariants}
        />
        
        {/* Line Chart Effect */}
        <motion.path 
          d="M5 40L15 30L25 35L35 25L45 30" 
          stroke={darkMode ? '#FFFFFF' : '#152649'} 
          strokeWidth="2"
          strokeLinecap="round"
          fill="none"
          variants={pathVariants}
        />
        
        {/* Dollar Symbol */}
        <motion.path 
          d="M25 12L25 8M25 12C23.8954 12 23 12.8954 23 14C23 15.1046 23.8954 16 25 16C26.1046 16 27 16.8954 27 18C27 19.1046 26.1046 20 25 20M25 12C26.1046 12 27 12.8954 27 14M25 20L25 24M25 20C23.8954 20 23 19.1046 23 18" 
          stroke={darkMode ? '#FFFFFF' : '#152649'} 
          strokeWidth="2"
          strokeLinecap="round"
          variants={pathVariants}
        />
      </motion.svg>
      
      {/* Text */}
      <motion.div 
        className={`flex flex-col leading-none ${darkMode ? 'text-white' : 'text-neutral-800'}`}
        variants={textVariants}
      >
        <div className="flex items-baseline">
          <span className={`text-xl font-bold tracking-tight ${darkMode ? 'text-white' : 'text-primary-600'}`}>WEALTH</span>
          <span className={`text-xl font-light tracking-tight ml-1 ${darkMode ? 'text-white/80' : 'text-secondary-500'}`}>QUOTA</span>
        </div>
        <span className={`text-xs font-medium tracking-widest uppercase mt-1 ${darkMode ? 'text-white/90' : 'text-primary-500'}`}>
          Investment Group
        </span>
      </motion.div>
    </motion.div>
  );
};

export default Logo;